import { ReactElement } from "react";
import {
  useEarlyAccessCustomerState,
  CUSTOMER_STATE,
} from "../../hooks/useEarlyAccessCustomerState";
import LogInButton from "../logInButton/LogInButton";
import NotifyMeButton from "../notifyMeButton/NotifyMeButton";

interface EarlyAccessButtonProps {
  renderAddToBag: () => ReactElement;
  customerAccess: string;
}

export default function EarlyAccessButton({
  renderAddToBag,
  customerAccess,
}: EarlyAccessButtonProps) {
  const { customerState, setCustomerState } =
    useEarlyAccessCustomerState(customerAccess);

  switch (customerState) {
    case CUSTOMER_STATE.LOGGED_OUT:
      return <LogInButton />;
    case CUSTOMER_STATE.LOYALTY_NONE_OPTED_OUT_MARKETING:
    case CUSTOMER_STATE.LOYALTY_NONE_OPTED_IN_MARKETING:
    case CUSTOMER_STATE.LOYALTY_VIEW_OPTED_OUT_MARKETING:
      return (
        <NotifyMeButton
          customerState={customerState}
          setCustomerState={setCustomerState}
        />
      );
    case CUSTOMER_STATE.LOYALTY_PURCHASE:
    case CUSTOMER_STATE.LOYALTY_VIEW_OPTED_IN_MARKETING:
      return renderAddToBag();
    default:
      return null;
  }
}
